import AppFunction from "../../../../../core/helpers/app/AppFunction.js";

export const tableConditions = {
    data() {
        return {
            tableColumns: [
                { title: this.$t('product_type'), type: 'text', key: 'product_type' },
                { title: this.$t('action'), type: 'action', key: 'action' },
            ]
        };
    }
}